// @flow
export const FREE_BUSY_MEETING_URL = 'https://freebusy.io/meet';